import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "./scroll";

export default function useHashScroll() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => scrollToHash(hash), 300);
      return () => window.clearTimeout(t);
    }
  }, [hash, pathname]);
}
